import axios from "axios";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";
import { useNavigate } from "react-router";

export function useVerifyCode() {
  const [openModal, setOpenModal] = useState(false);
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
  useOpenSnackbar();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/auth/verify`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        setOpenModal(true);
      },
      onError: (error)=>{
        openSnackbar('error', error?.response?.data?.message)
    }
      
    }
  );

  const verify = (data) => {
    mutate({ code: data.otp, email: data.email });
  };

  return {
    severity, message, openToast, setOpenToast, duration,
    openModal,
    setOpenModal,
    loading: isLoading,
    verify,
  };
}

export function useResendCode() {
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
  useOpenSnackbar();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/auth/verify/resend`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
     
        openSnackbar('success', response?.message)
 
      },
      onError: (error)=>{
        openSnackbar('error', error?.response?.data?.message)
    }
    }
  );

  return {
    severity2: severity, 
    message2: message, 
    openToast2: openToast, 
    setOpenToast2: setOpenToast, 
    duration2: duration,
    loading: isLoading,
    resend: mutate,
  };
}


export function useVerifyCodeForgotPassword() {
  const [openModal, setOpenModal] = useState(false);
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
  useOpenSnackbar();
  const [email, setEmail] = useState('')
  const navigate = useNavigate()
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/auth/verify`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
          navigate('/create-new-password', {
            state:{
              email
            }
          })
      },
      onError: (error)=>{
        //openSnackbar('error', error?.response?.data?.message)
    }
      
    }
  );

  const verify = (data) => {
  
    setEmail(data.email)
    mutate({ code: data.otp, email: data.email });
  };

  return {
    severity, message, openToast, setOpenToast, duration,
    openModal,
    setOpenModal,
    loading: isLoading,
    verify,
  };
}